export default "__VITE_ASSET__BBGemLDX__"